import { render, staticRenderFns } from "./ApprovalAccessChange.vue?vue&type=template&id=213ccedf&scoped=true"
import script from "./ApprovalAccessChange.vue?vue&type=script&lang=js"
export * from "./ApprovalAccessChange.vue?vue&type=script&lang=js"
import style0 from "./ApprovalAccessChange.vue?vue&type=style&index=0&id=213ccedf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ccedf",
  null
  
)

export default component.exports